import type React from "react";

import { Box } from "@similarweb/ui-components/foundations";

import type { IFilterViewBaseProps } from "app/pages/sales-intelligence/modules/advanced-search-filtering/types/filterInstance";

import type FindAppsRatingFilter from "../../../models/RatingFilter/RatingFilter";

import { NumberOfRatings } from "./components/NumberOfRatings/NumberOfRatings";
import { Score } from "./components/Score/Score";

export const AppsRatingFilter: React.FC<IFilterViewBaseProps<FindAppsRatingFilter>> = ({
    filter,
    value,
    onFilterUpdate,
}) => {
    return (
        <Box width="260px">
            <Score
                filter={filter}
                onFilterUpdate={onFilterUpdate}
                value={value}
            />
            <NumberOfRatings
                filter={filter}
                onFilterUpdate={onFilterUpdate}
                value={value}
            />
        </Box>
    );
};
